import LivedigitalSDKError from './LivedigitalSDKError';

class UnauthorizedError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Unauthorized';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? UnauthorizedError.DEFAULT_MESSAGE, errorCode ?? 'unauthorized', meta);
  }
}

export default UnauthorizedError;
